/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ISelectedStoreViewProps } from './components/selected-store/selected-store';
import { IStoreSelectorWorldwideViewProps } from './find-store-worldwide';

/**
 * Render the selected store.
 * @param props -- Selected store view props.
 * @returns -- HTML.
 */
const renderSelectedStore: React.FC<ISelectedStoreViewProps> = props => {
    const {
        storeDetailsMain,
        // storeHeader,
        // storeName,
        // storeDetailsCloseButton,
        // storeDistance,
        // isCurrentLocation,
        // currentLocation,
        storeRenderedComponent
    } = props;

    return (
        <Node {...storeDetailsMain}>
            {/* <Node {...storeHeader}>
                {storeDetailsCloseButton}
                {storeName}
                {storeDistance}
            </Node> */}
            {storeRenderedComponent}
            {/* {isCurrentLocation ? currentLocation : null} */}
        </Node>
    );
};

// /**
//  * Render the body of the popup.
//  * @param props -- Store selector view props.
//  * @returns -- Returns the html.
//  */
// const renderBody: React.FC<IStoreSelectorWorldwideViewProps> = props => {
//     const {
//         BodyContainerProps,
//         locationsMessage,
//         search,
//         state,
//         spinner,
//         locationsList,
//         noLocationsMessage,
//         maps,
//         bodyWrapperProps,
//         storeResultContainerProps,
//         mapContainerProps,
//         // isMobileView,
//         storeDetailsModal,
//         selectedLocation
//     } = props;

//     // if (isMobileView) {
//     //     return (
//     //         <Node {...BodyContainerProps}>
//     //             {/* {locationsMessage} */}
//     //             {search}
//     //             <Node {...bodyWrapperProps!}>
//     //                 <Node {...storeResultContainerProps!}>
//     //                     {locationsMessage}
//     //                     {state.isSearchInProgress ? spinner : <>{locationsList ? locationsList : noLocationsMessage}</>}
//     //                     {/* {maps} */}
//     //                     <Node {...storeDetailsModal!}>{selectedLocation && renderSelectedStore(selectedLocation)}</Node>
//     //                 </Node>
//     //             </Node>
//     //         </Node>
//     //     );
//     // }

//     return (
//         <div className='storelocatorflex'>
//             <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
//                 <Node {...BodyContainerProps}>
//                     <Node {...bodyWrapperProps!}>
//                         <Node {...storeResultContainerProps!}>
//                             {search}
//                             {locationsMessage}
//                             {state.isSearchInProgress ? spinner : <>{locationsList ? locationsList : noLocationsMessage}</>}
//                         </Node>
//                     </Node>
//                 </Node>
//             </div>
//             <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
//                 <Node {...mapContainerProps!}>{maps}</Node>
//                 <Node {...storeDetailsModal!}>{selectedLocation && renderSelectedStore(selectedLocation)}</Node>
//             </div>
//         </div>
//     );
// };

/**
 * Store selector view props.
 * @param props - Store selector view props.
 * @returns - HTML.
 */
const StoreSelectorView: React.FC<IStoreSelectorWorldwideViewProps> = props => {
    const {
        FooterContainerProps,
        FooterContainerPropsMaps,
        HeaderContainerProps,
        HeaderProps,
        ModuleProps,

        terms,
        BodyContainerProps,
        locationsMessage,
        search,
        state,
        spinner,
        locationsList,
        noLocationsMessage,
        maps,
        bodyWrapperProps,
        storeResultContainerProps,
        mapContainerProps,
        // isMobileView,
        storeDetailsModal,
        selectedLocation,
        SearchBarSectionMapOnlyMobileClassName
    } = props;

    return (
        <div className='container'>
            <div className='row'>
                <div className={`col-12 col-sm-12 col-md-6 col-lg-6${SearchBarSectionMapOnlyMobileClassName}`}>
                    <Module {...ModuleProps}>
                        <Node {...HeaderContainerProps}>{HeaderProps}</Node>
                        <Node {...BodyContainerProps}>
                            <Node {...bodyWrapperProps!}>
                                <Node {...storeResultContainerProps!}>
                                    {search}
                                    {locationsMessage}
                                    {state.isSearchInProgress ? spinner : <>{locationsList ? locationsList : noLocationsMessage}</>}
                                </Node>
                            </Node>
                        </Node>
                        <Node {...FooterContainerProps}>{terms}</Node>
                    </Module>
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6'>
                    <Node {...mapContainerProps!}>{maps}</Node>
                    <Node {...storeDetailsModal!}>{selectedLocation && renderSelectedStore(selectedLocation)}</Node>
                    <Node {...FooterContainerPropsMaps}>{terms}</Node>
                </div>
            </div>
        </div>
    );
};

export default StoreSelectorView;
